import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {Options} from 'ng5-slider';

@Component({
  selector: 'slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {
  @Input() stepNames;
  @Input() reverseTop: boolean;
  @Input() value;
  @Output() onValueChanged = new EventEmitter();
  options: Options = {
    floor: 0,
    ceil: 10,
    step: 1,
    showTicksValues: true
  };

  constructor() { }

  ngOnInit() {
    this.options.ceil = this.stepNames.length - 1;
    this.options.translate = (value: number): string => this.stepNames[value];
  }

  onUserChange(event) {
    this.onValueChanged.emit(event);
  }

}
